import { useMemo } from 'react';

import { useAppSelector } from './useAppSelector';

const useRoles = () => {
    const { userData } = useAppSelector((state) => state.auth);

    const role = useMemo(() => {
        if (!userData?.role) {
            return null;
        }

        return userData.role;
    }, [userData]);

    const hasRole = (r: string) => {
        if (!r) {
            return true;
        }

        return role?.slug === r;
    };

    const hasSomeRoles = (roles: string[]) => {
        if (!roles) {
            return false;
        }

        return roles.some((r) => hasRole(r));
    };

    const hasSomeAchatCashRole = () =>
        hasSomeRoles([
            'conseiller-achat-cash-distance',
            'conseiller-achat-cash-concession',
            'manager-achats-cash',
            'conseiller-achat-cash-hybride',
        ]);

    return {
        hasRole,
        hasSomeRoles,
        hasSomeAchatCashRole,
    };
};

export default useRoles;
